<template>
  <el-form ref="passwordForm" :model="formData" :rules="rules"  label-position="left" label-width="auto" style="width: 600px" >
    <el-form-item  :label="$t('lang.设置您的密码')" prop="password">
      <el-input v-model="formData.password" type="password"></el-input>
    </el-form-item>

    <el-form-item :label="$t('lang.再次输入密码')" prop="rePassword">
      <el-input v-model="formData.rePassword" type="password"></el-input>
    </el-form-item>

    <el-form-item size="medium" style="display: flex;justify-content: center">
      <el-button size="medium" type="primary" style="width: 120px" @click="handleNext">{{ $t('lang.下一步') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: "SetPasswordForm",
  data() {
    return {
      formData: {
        password: '',
        rePassword: ''
      }
    }
  },
  computed: {
    rules() {
      let checkRePassword = (rule, value, callback) => {
        if (value != this.formData.password) {
          let errText = this.$t('lang.两次输入密码不相同，请重新输入')
          return callback(new Error(errText));
        }
        callback();
      };
      return {
        password: [
          { required: true, message: this.$t('lang.请输入密码'), trigger: 'blur' },
          { min: 8, message: this.$t('lang.密码需以数字字母组成，并不能少于8位'), trigger: 'blur' }
        ],
        rePassword: [
          { required: true, message: this.$t('lang.请输入密码'), trigger: 'blur' },
          { min: 8, message: this.$t('lang.密码需以数字字母组成，并不能少于8位'), trigger: 'blur' },
          { validator: checkRePassword, trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    handleNext() {
      const vm = this;
      this.$refs['passwordForm'].validate((valid) => {
        if (valid) {
          vm.$emit('next', vm.formData);
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
